import React from 'react';
import './NewLoader.css';

const CircleLoader = () => <div className="circle-loader"></div>;

export default CircleLoader;
